import { HeaderContent } from "@/common/lib/types";
import { createContext, useContext } from "react";

type NavCtxType = {
  isScrolling: boolean;
  isAtTop: boolean;
  isHomePage: boolean;
  animation?: string;
  duration?: string;
  dynamicHeader?: boolean;
  isLinkHovered?: boolean;
  navData: HeaderContent;
  notificationHeaderShown?: boolean;
  handleIsLinkHovered?: (isHovered: boolean) => void;
};

export const NavCtx = createContext<null | NavCtxType>(null);

export function useNavContext() {
  const ctx = useContext(NavCtx);
  if (ctx === null) throw new Error("Nav context must be used inside a nav context");
  return ctx;
}
